import axios from 'axios';
import config from '../config';
import { getIdToken, refreshCognitoSession } from '../utils/cognitoSession';

const { basePath } = config;

const fetcher = async ({
    method = 'GET',
    url,
    data,
    headers,
    params,
    callbacks,
    token,
}) => {
    const resolvedToken = token || (await getIdToken());

    const execute = async (authToken, isRetry) => {
        try {
            return await axios({
                method,
                url: `${basePath}${url}`,
                data,
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    ...headers,
                },
                params,
            });
        } catch (ex) {
            if (!isRetry && ex?.response?.status === 401) {
                const session = await refreshCognitoSession();
                return execute(session.getIdToken().jwtToken, true);
            }
            throw ex;
        }
    };

    return execute(resolvedToken, false);
};

export default fetcher;
